import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ActionSheetController, PopoverController, ModalController, ToastController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { VehicleService } from '../../../vehicles';
import { SocketImplementation } from '../../../socket';
import { LoginPage } from '../../login/login';

/**
 * Generated class for the GlhomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-glhome',
  templateUrl: 'glhome.html',
})
export class GlhomePage {
  myLoadingData: any
  selectedModal: any;
  tmpDate: any;
  toggleNotifications: boolean = false;
  flagAnimate = 1;
  closeFlagAnimate = 0;
  closeFlagAnimateSingle = -1;
  feedbackexpand = false
  rootPage: any
  constructor(public navCtrl: NavController, public dic: DIC, public gn: GN, public vs: VehicleService,
    public toastCtrl: ToastController, public modalCtrl: ModalController, public popoverCtrl: PopoverController,
    public actionSheetCtrl: ActionSheetController, public alertCtrl: AlertController, public loadingCtrl: LoadingController) {

    this.tmpDate = new Date();
    //d-m-Y H:i:s
    // console.log(gn.user.zone)
    // console.log(moment().format(gn.user.TFormat))
    // console.log(moment().format('HH:mm:ss'))

    // console.log('Vlegov vo Home.TS')
    gn.Socket = new SocketImplementation(gn, vs);
    gn.Socket.connect()

    // this.myLoadingData = this.toastCtrl.create({ message: this.dic.l["waitloadingdata"], position: 'top' });
    this.myLoadingData = this.loadingCtrl.create({ content: this.dic.l["waitloadingdata"], cssClass: 'waitloadingdata' });
    this.myLoadingData.present();
    var _that = this
    vs.loadInitVehicles(function () {
      _that.myLoadingData.dismiss()
      _that.myLoadingData = null
      console.log(_that.gn.Vehicles)
      // _that.openWelcomeMessage()
    })
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad GlhomePage');
    this.gn.startIntervalForNotifications()
  }
  logout() {
    if (this.myLoadingData != null) { return }
    this.gn.clearData()
    this.navCtrl.setRoot(LoginPage)
  }

}



// WEBPACK FOOTER //
// ./src/pages/gps-link/glhome/glhome.ts